<ng-template #fileListItem let-file="file">
  <div class="col flex-gap-5">
    @if (file?.mimeType?.includes('image/')) {
      <i class="fa fa-file-image" title="Image"></i>
    }
    @if (
      file?.mimeType?.includes('text/') ||
      file?.mimeType?.includes('/msword') ||
      file?.mimeType?.includes('wordprocessingml')
    ) {
      <i class="fa fa-file-text" title="Text"></i>
    }
    @if (file?.mimeType?.includes('application/pdf')) {
      <i class="fa fa-file-pdf" title="Pdf"></i>
    }
    @if (file?.mimeType?.includes('spreadsheet') || file?.mimeType?.includes('ms-excel')) {
      <i class="fa fa-file-excel" title="Excel"></i>
    }
    @if (unknownType(file?.mimeType)) {
      <i class="fa fa-file" title="File"></i>
    }
    <a class="link" href="{{ file?.url }}" target="_blank" data-cy="file-url">
      {{ file?.originalFilename || file?.text || 'file' }}
    </a>
  </div>
  @if (!readonly) {
    <btn
      class="align-self-center"
      [title]="'delete' | translate"
      [icon]="'far-trash-alt'"
      (onEvent)="deleteFile(file)"
      [classes]="['btn-sm', 'btn-trash']"
      [dataCyAttribute]="'delete-file'"
    ></btn>
  }
</ng-template>

<div class="card">
  <div class="row">
    <div class="col-12">
      <h3 class="card-title">
        {{ 'files' | translate }}
      </h3>
    </div>
  </div>

  @if (!readonly) {
    <div class="row mt-2">
      <div class="col-12 mb-2" title="{{ 'allowed-file-types' | translate }}">
        <form-row-input
          [icon]="'far-upload'"
          [inputType]="'file'"
          [inputMultiple]="true"
          (valueChangeNative)="uploadFiles($event)"
          [noMarginBottom]="true"
          [dataCyAttribute]="'order-upload-file'"
        ></form-row-input>
      </div>
    </div>
  }

  @if (areFilesUploading) {
    <div class="overlay no-print">
      <div class="spinner-border text-primary spinner-border-sm mb-2" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  }

  @if ((!isOnPurchaseOrder && !orderFiles.length) || (isOnPurchaseOrder && !poFiles.length)) {
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-center align-items-center">
        <div class="card-subheading">{{ 'no-files' | translate }}</div>
      </div>
    </div>
  }

  @if (!isOnPurchaseOrder && orderFiles.length) {
    <div>
      @for (file of orderFiles; track file) {
        <div class="d-flex mt-2 flex-gap-5 padding-left-2 padding-right-2">
          <ng-container *ngTemplateOutlet="fileListItem; context: { file: file }"></ng-container>
        </div>
      }
    </div>
  }

  @if (isOnPurchaseOrder && poFiles.length) {
    <div>
      @for (file of poFiles; track file) {
        <div class="d-flex mt-2 flex-gap-5 padding-left-2 padding-right-2">
          <ng-container *ngTemplateOutlet="fileListItem; context: { file: file }"></ng-container>
        </div>
      }
    </div>
  }
</div>
